module.exports = __webpack_public_path__ + "img/Nocoes_Radiologicas_para_Enfermagem.beff9d3d.jpg";